export function objectPatch<T>(obj: Readonly<{ [index: string]: T }>,
                               key: string,
                               value: T): { [index: string]: T };
export function objectPatch<T>(obj: Readonly<{ [index: number]: T }>,
                               key: number,
                               value: T): { [index: number]: T };
export function objectPatch<T>(obj: Readonly<{ [index: string]: T }>,
                               key: string | number,
                               value: T): { [index: string]: T } {
  const patch: { [index: string]: T } = {};
  patch[key] = value;
  return Object.assign({}, obj, patch);
}
